// useSound delega al SoundContext global para garantizar
// una unica instancia compartida en toda la aplicacion.
import { useSoundContext } from '../contexts/SoundContext';

export const useSound = () => useSoundContext();

